/**
 * OlympusIcon — Offizielles Olympus-Logo (Berg + KI-Orbit)
 * 
 * Props:
 *   size      — Pixelgröße (Breite = Höhe), default: 32
 *   className — optionale CSS-Klasse
 *   withBg    — weißer Kreis-Hintergrund für dunkle Kontexte (default: false)
 */
export default function OlympusIcon({ size = 32, className = "", withBg = false }) {
  const img = (
    <img
      src="/olympus-logo-transparent.png"
      alt="Olympus"
      width={withBg ? Math.round(size * 0.85) : size}
      height={withBg ? Math.round(size * 0.85) : size}
      style={{ objectFit: 'contain' }}
      draggable={false}
    />
  );

  if (withBg) {
    return (
      <div
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {img}
      </div>
    );
  }

  return <span className={className} style={{ display: 'inline-flex', flexShrink: 0 }}>{img}</span>;
}
